import { Box, Button } from '@mui/material';
import BulkNextPaymentNew from './BulkNextPaymentNew';
import BulkNextPaymentOld from './BulkNextPaymentOld';
import React, { useRef } from 'react';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import { bulkNextPayment, getCartItems } from '../../../../redux/features/cartSlice';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { useLocation } from 'react-router-dom';

const BulkNextPaymentForm = ({ formData, setOpen }) => {
  const handleApiResponse = useHandleApiResponse();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const formRefs = useRef([]);
  const { loading } = useSelector((state) => state.cart);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const leadIdParams = params.get('leadId');

  const handleCollectAll = () => {
    const result = formRefs.current.map((ref) => ref?.current?.getValues?.()).filter(Boolean);

    // --- Validation Logic ---
    if (!Array.isArray(result) || result.length === 0) {
      enqueueSnackbar('No form data found.', {
        variant: 'error',
      });
      return;
    }

    // Check if ANY object has payingAmt empty
    const hasEmptyPayingAmt = result.some((item) => item?.payingAmt === '' || item?.payingAmt == null);

    if (hasEmptyPayingAmt) {
      enqueueSnackbar('Some paying amount is empty.', {
        variant: 'error',
      });
      return;
    }

    // --- All Good ---

    dispatch(bulkNextPayment(result)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
          const leadId = location?.state?.leadId;
          dispatch(getCartItems(leadId || leadIdParams));
        },
        onFailed: () => {
          console.log('Something went wrong');
        },
      });
    });

    // Continue your API logic here
  };

  return (
    <Box>
      {formData.map((paidItem, index) => {
        if (!formRefs.current[index]) {
          formRefs.current[index] = React.createRef();
        }

        return paidItem.selectedOption ? (
          <BulkNextPaymentNew key={paidItem.cartId} ref={formRefs.current[index]} paidItem={paidItem} />
        ) : (
          <BulkNextPaymentOld key={paidItem.cartId} ref={formRefs.current[index]} paidItem={paidItem} />
        );
      })}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Button disabled={loading} variant="contained" onClick={handleCollectAll}>
          {loading ? 'Please wait...' : 'Generate Link'}
        </Button>
      </Box>
    </Box>
  );
};

export default BulkNextPaymentForm;
